import { render, staticRenderFns } from "./traitements_chroniques.vue?vue&type=template&id=1cc4bfa5&"
import script from "./traitements_chroniques.vue?vue&type=script&lang=js&"
export * from "./traitements_chroniques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports